export interface EquipmentModelsPaginationRequest {
  page?: number;
  limit?: number;
}

export interface AttributeOption {
  ID: string;
  Label: string;
}

export interface AlertRule {
  BeforeMonths: number;
  AfterMonths: number;
}

export type AttributeType = "string" | "number" | "date" | "list" | "comments";

export interface EquipmentAttributeDefinition {
  ID: string;
  Label: string;
  Type: AttributeType;
  Options?: AttributeOption[];
  Alert?: AlertRule;
}

export interface PrefilterCriteria {
  AttributeID: string;
  Operator: string;
  Value: string;
}

export interface EquipmentPrefilter {
  ID: string;
  Name: string;
  Criteria: PrefilterCriteria[];
  Logic: "AND" | "OR";
}

export interface FilterCriteria {
  AttributeID: string;
  Operator:
    | "="
    | "!="
    | "<>"
    | ">"
    | "<"
    | ">="
    | "<="
    | "LIKE"
    | "ILIKE"
    | "NOT LIKE"
    | "NOT ILIKE";
  Value: string;
  Type: "number" | "date" | "list" | "string" | "period";
}

export interface EquipmentFilters {
  Criteria: FilterCriteria[];
  Logic: "AND" | "OR";
}

export interface EquipmentSearchRequest {
  ModelID: number;
  Page?: number;
  Limit?: number;
  PrefilterID?: string;
  Filters?: EquipmentFilters;
  SortBy?: string;
  SortOrder?: "ASC" | "DESC";
}

export interface QRCodeInfo {
  EquipmentID: string;
  Owner: string;
  Address: string;
  City: string;
  PostalCode: string;
  Country: string;
  Phone: string;
  Email: string;
}

export interface EquipmentQRCode {
  QRCode: string;
  BackgroundColor: string;
}

export type EquipmentRentalStatus = "in_stock" | "not_rentable" | "rented" | "available";

export interface Equipment {
  ID?: string;
  ModelID: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- dynamic attribute map from API (mixed value shapes per model)
  Attributes: { [key: string]: any };
  QRCode?: EquipmentQRCode;
  // The Go field carries an explicit `json:"rental_status"` tag, so the API returns it as snake_case
  // even though most other Equipment fields keep PascalCase keys.
  rental_status?: EquipmentRentalStatus;
  rfid_tag_id?: string | null;
  CreatedAt?: string;
  UpdatedAt?: string;
}

export enum AlertSeverity {
  INFO = "info",
  WARNING = "warning",
  CRITICAL = "critical",
}

export interface AlertModelRule {
  ID: string;
  Name: string;
  Filters?: EquipmentFilters;
  Operator: "=" | "!=" | ">" | ">=" | "<" | "<=";
  Value: number;
  Severity?: AlertSeverity;
  Type?: string;
  Enabled: boolean;
}

export interface EquipmentModel {
  ID?: number;
  Name: string;
  Description?: string;
  Attributes: EquipmentAttributeDefinition[];
  Prefilters?: EquipmentPrefilter[];
  Alerts?: AlertModelRule[];
  CreatedAt?: string;
}
